import React, { useState } from "react";
import { LogOut, Settings } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import SettingsPanel from "./SettingsPanel";

const TooltipButton = ({ onClick, className, title, children }) => (
	<div className="group relative">
		<div
			className="absolute left-1/2 -translate-x-1/2 sm:-top-8 top-10 px-2 py-1 bg-gray-900 dark:bg-gray-700 
      text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50"
		>
			{title}
		</div>
		<button onClick={onClick} className={className} aria-label={title}>
			{children}
		</button>
	</div>
);

const UserMenu = ({ className = "" }) => {
	const { user, logout } = useAuth();
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);
	const [isSettingsOpen, setIsSettingsOpen] = useState(false);

	const handleLogout = () => {
		logout();
		navigate("/login");
	};

	const handleSettings = () => {
		setIsOpen(false); // Close the menu
		setIsSettingsOpen(true); // Open settings panel
	};

	return (
		<>
			{/* Main Menu Button and Dropdown */}
			<div className={`relative ${className}`}>
				<div
					className={`
            absolute right-full top-1/2 -translate-y-1/2 flex items-center mr-2
            transition-all duration-300 ease-in-out
            ${
							isOpen
								? "opacity-100 translate-x-0"
								: "opacity-0 translate-x-8 pointer-events-none"
						}
          `}
				>
					<div className="flex items-center space-x-2 bg-white dark:bg-gray-800 rounded-full shadow-lg p-2">
						<TooltipButton
							onClick={handleLogout}
							className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors duration-200"
							title="Logout"
						>
							<LogOut className="w-5 h-5 text-gray-600 dark:text-gray-400" />
						</TooltipButton>

						<div className="w-px h-6 bg-gray-200 dark:bg-gray-700" />

						<TooltipButton
							onClick={handleSettings}
							className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors duration-200"
							title="Settings"
						>
							<Settings className="w-5 h-5 text-gray-600 dark:text-gray-400" />
						</TooltipButton>
					</div>
				</div>

				<button
					onClick={() => setIsOpen(!isOpen)}
					className="relative z-10 transition-transform duration-200 hover:scale-105 focus:outline-none"
				>
					<img
						src={user?.picture}
						alt="User avatar"
						className="w-8 h-8 rounded-full ring-2 ring-white dark:ring-gray-800"
						crossOrigin="anonymous"
						referrerPolicy="no-referrer"
					/>
				</button>
			</div>

			{/* Settings Panel Portal */}
			<div className="relative">
				<SettingsPanel
					isOpen={isSettingsOpen}
					onClose={() => setIsSettingsOpen(false)}
				/>
			</div>
		</>
	);
};

export default UserMenu;
